export default __webpack_public_path__ + "static/media/WeeklyPlanLine.69187545.svg";